const { location } = require('@wix/site-location');
async function logUrlPath() {
  const path = await location.path();
  console.log(`path is:  ${path}`);
}
module.exports = {
  logUrlPath,
};
